import type * as React from 'react';
import { getPaginated } from '@Domain/Api';
import documentTemplatesFetched, {
	type DocumentTemplatePayload,
	type DocumentTemplatesFetchedAction,
} from '@Application/Documents/Templates/Actions/documentTemplatesFetched';
import documentTemplatesFetchFailed, {
	type DocumentTemplatesFetchFailedAction,
} from '@Application/Documents/Templates/Actions/documentTemplatesFetchFailed';
import type FetchDocumentTemplates from '@Application/Documents/Templates/Queries/FetchDocumentTemplates';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTemplatesFetchedAction | DocumentTemplatesFetchFailedAction;

type PaginatedDocumentTemplates = {
	totalRecords: number;
	results: DocumentTemplatePayload[];
};

export default (query: FetchDocumentTemplates) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// The front reads the whole organization's catalog in one go: `getPaginated` walks every
			// page starting from `page: 0` (its internal guard only rejects `page > 1`).
			const response = await getPaginated<PaginatedDocumentTemplates>(
				`${parameters.api.host}/api/organizations/${query.organizationId}/document-templates`,
				{ page: 0, rowsPerPage: 200 },
			);

			const action = documentTemplatesFetched(response.results, query.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTemplatesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
